module.exports = __webpack_public_path__ + "static/media/diversity-icon.4655faa1.svg";